import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import history from "../../services/history"

import { actions as appActions } from "../../modules/appModule"

import NavBar from "../../components/layout/DashboardNavbar"
import DeleteAccountConfirmForm from "../../forms/DeleteAccountConfirmForm"
import Page, { Content } from "../../components/Page"
import Footer from "../../components/Footer"

class DeleteAccountConfirm extends Component {

  componentDidMount() {
    // clear any leftover confirm-account error from an earlier, unrelated confirmation attempt
    this.props.app.confirmAccountError(null)
  }

  render() {
    return (
      <Page>
        <NavBar authorized title="Delete Account?" backLink portrait={this.props.portrait} />

        <Content scroll>
          <div className="form-page">
            <div className="form-cell">
              <div className="form-wrapper">
                <DeleteAccountConfirmForm
                  onSubmit={() => this.props.app.deleteMe()}
                  cancelDelete={() => { history.goBack() }}
                />
                <p className="error-message">
                  {this.props.confirmError}
                </p>
              </div>
            </div>
          </div>
        </Content>

        <Footer urlSource={this.props.urlSource} />
      </Page>
    )
  }
}

const mapStateToProps = ({ app, common, user }) => {
  return {
    confirmError: app.confirmError,
    resendResult: app.resendResult,
    urlSource: common.urlSource,
    portrait: user.portrait,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccountConfirm)


